import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { timeline as fallback } from "@/data/portfolio";

export default function Experience() {
  const [items, setItems] = useState(fallback);

  useEffect(() => {
    let active = true;
    api
      .get("/timeline")
      .then(({ data }) => {
        if (active && Array.isArray(data) && data.length) setItems(data);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="relative py-16 md:py-20 lg:py-24 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex items-center gap-3 text-sm text-zinc-500"
        >
          <span className="w-8 h-px bg-zinc-700" />
          <span>02 · Trajectory</span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="font-heading mt-5 text-3xl md:text-5xl lg:text-6xl font-light tracking-[-0.025em] leading-[1.05] text-white max-w-3xl"
        >
          A timeline of{" "}
          <span className="text-zinc-500">curiosity compounding.</span>
        </motion.h2>

        <div className="mt-10 md:mt-14 relative">
          <div className="absolute left-[7px] md:left-[11px] top-2 bottom-2 w-px bg-gradient-to-b from-white/30 via-white/10 to-transparent" />

          <ol className="space-y-8 md:space-y-10">
            {items.map((t, i) => (
              <motion.li
                key={t.id || i}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
                data-testid={`timeline-item-${i}`}
                className="pl-10 md:pl-16 relative"
              >
                <span className="absolute left-0 top-1.5 flex h-4 w-4 md:h-6 md:w-6 items-center justify-center">
                  <span className="absolute inset-0 rounded-full bg-white/10 blur-md" />
                  <span className="relative inline-block h-2.5 w-2.5 md:h-3 md:w-3 rounded-full bg-white shadow-[0_0_24px_rgba(255,255,255,0.6)]" />
                </span>
                <div className="text-sm text-zinc-500">{t.period}</div>
                <h3 className="font-heading mt-1.5 text-xl md:text-2xl font-medium tracking-tight text-white">
                  {t.title}
                </h3>
                <div className="mt-0.5 text-sm text-zinc-300">{t.org}</div>
                <p className="mt-3 max-w-2xl text-sm md:text-base text-zinc-400 font-light leading-relaxed">
                  {t.detail}
                </p>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
